import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { Translate, useI18n } from '@change-corgi/core-react/i18n';

import { PetitionQRCodeDownload } from '#src/app/pages/starterDashboardV2/shared/components';
import { InfoTooltip } from '#src/app/shared/components/tooltips';

import { FlyerDownloadLoader } from './components/FlyerDownloadLoader';
import { useShareYourPetitionOffline } from './hooks/useShareYourPetitionOffline';

export const ShareYourPetitionOffline: React.FC = () => {
	const {
		data: {
			shareAction: { ShareAction },
			slugOrId,
			downloadSize,
			displayType,
			downloadType,
			descriptionText,
			downloadLinkText,
			downloadFilename,
		},
	} = useShareYourPetitionOffline();
	const { translate } = useI18n();

	return (
		<section
			id="share_qrcode_module"
			data-qa="share-qrcode-module"
			className="bg-background-base flex scroll-mt-20 flex-col gap-6 px-4 py-8 md:scroll-mt-18 md:p-12"
			aria-label={translate(
				'corgi.petition.starter_dashboard_v2.grow_petition.share_petition_offline.section_aria_label',
			)}
		>
			<div className="text-typography-strong flex flex-row items-center gap-1">
				<Text as="h3" id="share-petition-offline-title" className="text-size-heading-small">
					<Translate value="corgi.petition.starter_dashboard_v2.grow_petition.share_petition_offline.title" />
				</Text>
				<InfoTooltip aria-describedby="share-petition-offline-title" tabIndex={0}>
					<Translate value="corgi.petition.starter_dashboard_v2.grow_petition.share_petition_offline.tooltip_posters" />
				</InfoTooltip>
			</div>
			<div>
				<ShareAction>
					<PetitionQRCodeDownload
						slugOrId={slugOrId}
						displaySize={112}
						downloadSize={downloadSize}
						displayType={displayType}
						downloadType={downloadType}
						descriptionText={descriptionText}
						downloadLinkText={downloadLinkText}
						downloadFilename={downloadFilename}
					/>
				</ShareAction>
			</div>
			<FlyerDownloadLoader />
		</section>
	);
};
